import e from "./Loader.module.js";
import "react";
import { jsxDEV as t } from "react/jsx-dev-runtime";
//#region lib/components/Loader/Loader.tsx
var n = "/opt/render/project/src/shared-ui/lib/components/Loader/Loader.tsx";
function r({ size: r = "sm", centered: i = !1, color: a = "var(--ag-neutral-solid-default)", ...o }) {
	return /* @__PURE__ */ t("div", {
		...o,
		className: `${e.loader} ${e[r]} ${o.className ?? ""} ${i ? e.centered : ""}`,
		style: {
			...o.style,
			"--ag-loader-color": a
		},
		children: /* @__PURE__ */ t("div", { children: [
			/* @__PURE__ */ t("div", {}, void 0, !1, {
				fileName: n,
				lineNumber: 27,
				columnNumber: 17
			}, this),
			/* @__PURE__ */ t("div", {}, void 0, !1, {
				fileName: n,
				lineNumber: 28,
				columnNumber: 17
			}, this),
			/* @__PURE__ */ t("div", {}, void 0, !1, {
				fileName: n,
				lineNumber: 29,
				columnNumber: 17
			}, this),
			/* @__PURE__ */ t("div", {}, void 0, !1, {
				fileName: n,
				lineNumber: 30,
				columnNumber: 17
			}, this)
		] }, void 0, !0, {
			fileName: n,
			lineNumber: 26,
			columnNumber: 13
		}, this)
	}, void 0, !1, {
		fileName: n,
		lineNumber: 21,
		columnNumber: 9
	}, this);
}
//#endregion
export { r as Loader };
